import styled from 'styled-components';

export const MotionEndStyled = styled.div`
  display: flex;
  flex-direction: column;
  jsutify-content: flex-start;
  gap: 1rem;
  padding: 0 1rem;
  flex: 1;

  .motion-card {
  }
`;
